
import { PropTypes } from 'prop-types';
import { FaFacebookF, FaLocationDot } from "react-icons/fa6";
import { BsInstagram, BsTelephoneFill, BsTwitterX, BsYoutube } from "react-icons/bs";
import { MdEmail } from 'react-icons/md';




const SocialIcon = ({ children }) => {
    return (
        <div className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-blue-700 bg-opacity-10 text-blue-700'>
            {children}
        </div>
    )

}
SocialIcon.propTypes = {
    children: PropTypes.element
}

const PeopleDetail = ({ people }) => {
    const socialIcons = [
        {
            icon: <FaFacebookF />,
            text: 'Facebook',
        },
        {
            icon: <BsTwitterX />,
            text: 'Twitter',
        },
        {
            icon: <BsInstagram />,
            text: 'Instagram',
        },
        {
            icon: <BsYoutube />,
            text: 'Youtube',
        },
    ]
    return (
        <div className="flex flex-col md:flex-row gap-5 w-full  p-4 max-h-[80vh] max-w-[80vw]  ">
            <div className="w-fit h-full bg-gray-200 rounded-2xl bg-center bg-cover bg-no-repeat overflow-hidden  min-w-full sm:min-w-[40%] lg:min-w-[30%] min-h-[15rem] md:min-h-[25rem]" style={{backgroundImage:`url('${people.img}')`}}>
                
            </div>
            <div className="flex flex-col w-full gap-3 h-full overflow-y-auto scroll-bar">
                <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{people.quote}</h1>
                <p className="text-neutral-500 text-xl font-medium w-auto max-w-6xl">{people.designation}</p>
                <p className="text-sky-950 text-opacity-70 text-base font-normal w-auto max-w-[90%]">{people.description}</p>
                <div className="flex flex-col gap-3 my-2">
                    <p className="text-neutral-700 text-sm sm:text-base font-medium flex items-center gap-2"><FaLocationDot size={23} />{people.location}</p>
                    <p className="text-neutral-700 text-sm sm:text-base font-medium flex items-center gap-2"><BsTelephoneFill size={23} />{people.phone}</p>
                    <p className="text-neutral-700 text-sm sm:text-base font-medium flex items-center gap-2"><MdEmail size={23} />{people.email}</p>
                </div>

                <ul className='flex gap-4 list-none items-center justify-center w-full lg:justify-start'>
                    {
                        socialIcons.map((socialIcon, index) => (
                            <li
                                key={index} className='group cursor-pointer text-gray-400 '>
                                <SocialIcon>{socialIcon.icon}</SocialIcon>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}
PeopleDetail.propTypes = {
    people: PropTypes.object
}
export default PeopleDetail